(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-b2b-form"] && !Shopify.designMode) return;
  try {
    
(function() {
  var form = document.getElementById('contact_form');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    var bodyField = document.getElementById('b2b_body_hidden');
    if (!bodyField) return;

    var company = (document.getElementById('b2b_company') || {}).value || '';
    var country = (document.getElementById('b2b_country') || {}).value || '';
    var volume = (document.getElementById('b2b_volume') || {}).value || '';
    var bizType = (document.getElementById('b2b_business_type') || {}).value || '';
    var message = (document.getElementById('b2b_message') || {}).value || '';

    var categories = [];
    var checkboxes = form.querySelectorAll('input[name="b2b_category[]"]:checked');
    for (var i = 0; i < checkboxes.length; i++) {
      categories.push(checkboxes[i].value);
    }

    var bodyLines = [
      'Company Name: ' + company,
      'Country / Region: ' + country,
      'Product Categories of Interest: ' + (categories.length ? categories.join(', ') : 'None selected'),
      'Estimated Monthly Order Volume: ' + (volume || 'Not specified'),
      'Business Type: ' + (bizType || 'Not specified'),
      '',
      'Message / Additional Requirements:',
      message
    ];

    bodyField.value = bodyLines.join('\n');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
